module.exports = "### ToolbarTitle Properties\n\na simple text that is displayed in the `Toolbar`.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/Toolbars/ToolbarTitle.md
 ** module id = 896
 ** module chunks = 0
 **/